import 'dayjs/locale/fr'

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

dayjs.extend(timezone)

export const format = (date: Date | number, format: string): string =>
  dayjs(date).tz('Europe/Paris').locale('fr').format(format)

export const formatDate = (date: string) =>
  dayjs(date).tz('Europe/Paris').format('DD.MM.YYYY')
